/**
 * FikoKesmeParametre Dialog — CNC Kesme Parametreleri (Speeds & Feeds) UI
 * Malzeme + takım → devir (RPM) + ilerleme (mm/dk) + talaş debisi.
 */
import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { KESME_MALZEMELERI, kesmeHesapla, KesmeSonuc } from './FikoKesmeParametre';

@Component({
  selector: 'fikoyt-kesme-parametre',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="kp">
    <div class="kp-row">
      <label>Malzeme</label>
      <select [(ngModel)]="malzemeIdx" (ngModelChange)="malzemeDegisti()">
        @for (m of malzemeler; track $index) { <option [ngValue]="$index">{{ m.ad }}</option> }
      </select>
    </div>
    <div class="kp-grid">
      <div class="kp-in"><label>Takım Ø (mm)</label><input type="number" [(ngModel)]="cap" (ngModelChange)="hesapla()" min="0.1" step="0.5"></div>
      <div class="kp-in"><label>Ağız (z)</label><input type="number" [(ngModel)]="agiz" (ngModelChange)="hesapla()" min="1"></div>
      <div class="kp-in"><label>Vc (m/dk)</label><input type="number" [(ngModel)]="vc" (ngModelChange)="hesapla()" min="1"></div>
      <div class="kp-in"><label>fz (mm/diş)</label><input type="number" [(ngModel)]="fz" (ngModelChange)="hesapla()" min="0.001" step="0.01"></div>
      <div class="kp-in"><label>ap derinlik</label><input type="number" [(ngModel)]="ap" (ngModelChange)="hesapla()" min="0" step="0.5"></div>
      <div class="kp-in"><label>ae genişlik</label><input type="number" [(ngModel)]="ae" (ngModelChange)="hesapla()" min="0" step="0.5"></div>
    </div>

    @if (sonuc) {
      <div class="kp-sonuc">
        <div class="kp-r vurgu"><span>Devir (n)</span><b>{{ f(sonuc.devirRpm,0) }} dev/dk</b></div>
        <div class="kp-r vurgu2"><span>İlerleme (Vf)</span><b>{{ f(sonuc.ilerlemeMmDk,0) }} mm/dk</b></div>
        <div class="kp-r"><span>Devir başına (fn)</span><b>{{ f(sonuc.fnMmDev,3) }} mm/dev</b></div>
        <div class="kp-r"><span>Talaş debisi (MRR)</span><b>{{ f(sonuc.mrrCm3Dk,1) }} cm³/dk</b></div>
      </div>
      <div class="kp-not">💡 Karbür takım, orta paso varsayılanları. Vc/fz takım üreticisi kataloğuna göre ayarlanmalı.</div>
    }
  </div>
  `,
  styles: [`
    .kp { padding:10px; min-width:290px; max-width:330px; font-size:11px; color:#e6f6ff;
      background:linear-gradient(180deg,rgba(0,40,60,.96),rgba(0,18,36,.98)); border-radius:6px; }
    .kp-row { display:flex; align-items:center; gap:8px; margin-bottom:8px; }
    .kp-row label { color:#5fd9f5; font-weight:600; }
    .kp-row select { flex:1; background:rgba(0,60,80,.8); border:1px solid rgba(0,200,220,.4); color:#fff; padding:5px; border-radius:4px; }
    .kp-grid { display:grid; grid-template-columns:1fr 1fr 1fr; gap:5px; }
    .kp-in { display:flex; flex-direction:column; gap:2px; }
    .kp-in label { font-size:9px; color:#5fd9f5; }
    .kp-in input { background:rgba(0,60,80,.8); border:1px solid rgba(0,200,220,.35); color:#fff; padding:4px; border-radius:4px; font-size:10px; outline:none; box-sizing:border-box; }
    .kp-sonuc { margin-top:10px; background:rgba(0,0,0,.35); border:1px solid rgba(0,200,220,.3); border-radius:5px; padding:8px; }
    .kp-r { display:flex; justify-content:space-between; padding:3px 0; border-bottom:1px solid rgba(0,200,220,.12); }
    .kp-r span { color:#9fe8f7; }
    .kp-r.vurgu { background:rgba(0,200,120,.16); margin:0 -8px 3px; padding:6px 8px; border:none; } .kp-r.vurgu b { color:#7dffc0; font-size:14px; }
    .kp-r.vurgu2 { background:rgba(0,150,220,.16); margin:0 -8px 3px; padding:6px 8px; border:none; } .kp-r.vurgu2 b { color:#7dd3ff; font-size:14px; }
    .kp-not { margin-top:8px; font-size:9px; color:#9fe8f7; line-height:1.4; }
  `]
})
export class FikoKesmeParametreComponent {
  @Input() anaGosterim: any = null;
  @Input() pencere: any;
  @Input() ayarlar: any = {};

  malzemeler = KESME_MALZEMELERI;
  malzemeIdx = 0;
  cap = 10; agiz = 4; vc = 400; fz = 0.10; ap = 5; ae = 5;
  sonuc: KesmeSonuc | null = null;

  constructor(private cd: ChangeDetectorRef) { this.sonuc = this.hesaplaInt(); }

  private hesaplaInt(): KesmeSonuc {
    return kesmeHesapla({ capMm: this.cap, agizSayisi: this.agiz, vc: this.vc, fz: this.fz, kesmeDerinlik: this.ap, kesmeGenislik: this.ae });
  }
  hesapla(): void { this.sonuc = this.hesaplaInt(); this.cd.detectChanges(); }
  malzemeDegisti(): void { const m = this.malzemeler[this.malzemeIdx]; this.vc = m.vc; this.fz = m.fz; this.hesapla(); }

  f(v: number, d = 0): string { return (v ?? 0).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: d }); }
}
